<template>
    <div class="main">
        <MyHeader index="1"></MyHeader>
        <div class="title">
            <div class="container" v-if=" this.$i18n.locale == 'zh_CN'">
                <h2>关于我们</h2>
                <h3>About Us</h3>
            </div>
            <div class="container" v-if=" this.$i18n.locale == 'en_US'">
                <h2>About Us</h2>
                <h3>关于我们</h3>
            </div>
        </div>
        <div class="aboutUsInfo">
            <div class="container">
            
            <nav aria-label="Breadcrumb" class="breadcrumb2">
			  <ul>
				<li><a href="/">{{ $t("header.home") }}</a> </li>
				<li><span style="margin-bottom:10px;"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 2 16 16">
  <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
</svg></span></li>
				<li><span aria-current="page">{{ $t("header.aboutUs") }}</span></li>
			  </ul>
			</nav>
			
                <div class="content">
                    <div class="leftMenu">
                        <ul>
                            <li class="on">
                                <router-link to="/aboutUs">
                                    <i>{{$t('ccapp.tit')}}</i>
                                    <b></b>
                                </router-link>
                            </li>
                            <li>
                                <router-link to="frame">
                                    <i>{{$t('ccapp.tit1')}}</i>
                                    <b></b>
                                </router-link>
                                <ul class="second" style="margin-top: 10px">
                                    <li>
                                        <router-link :to="{name:'figure',params:{id:1}}">
                                        
                                            <i>{{$t('ccapp.tit2')}}</i>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link :to="{name:'figure',params:{id:2}}">
                                            <i>{{$t('ccapp.tit3')}}</i>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link :to="{name:'figure',params:{id:3}}">
                                            <i>{{$t('ccapp.tit4')}}</i>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <router-link to="job">
                                    <i>{{$t('ccapp.tit5')}}</i>
                                    <b></b>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="rightContent">
                        <h3>{{$t('ccapp.title')}}</h3>
                        <div class="textInfo">
                        	<div v-if=" this.$i18n.locale != 'zh_CN'"><span style="width:10px;background-color:#13AE67;color:#13AE67;margin-right:10px;">1</span>{{$t('main.text01')}}</div>
                            <p>{{$t('main.text')}}</p>
                            <!-- <p v-if=" this.$i18n.locale != 'zh_CN'">{{$t('main.text00')}}</p> -->
                            <div v-if=" this.$i18n.locale != 'zh_CN'"  style="margin-top:30px;"><span style="width:10px;background-color:#13AE67;color:#13AE67;margin-right:10px;">1</span>{{$t('main.text02')}}</div>
                            <p>{{$t('main.text1')}}</p>
                            <div v-if=" this.$i18n.locale != 'zh_CN'" style="margin-top:30px;"><span style="width:10px;background-color:#13AE67;color:#13AE67;margin-right:10px;">1</span>{{$t('main.text03')}}</div>
                            <p>{{$t('main.text2')}}</p>
                            <p>{{$t('main.text3')}}</p>
                            
                            <p v-if=" this.$i18n.locale != 'zh_CN'">{{$t('main.text4')}}</p>
            				<p v-if=" this.$i18n.locale != 'zh_CN'">{{$t('main.text5')}}</p>
            				<p v-if=" this.$i18n.locale != 'zh_CN'">{{$t('main.text6')}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <MyFooter></MyFooter>
    </div>
</template>

<script>
    import MyHeader from './common/MyHeader';
    import MyFooter from './common/MyFooter';
    export default {
        name: "AboutUsPage",
        components: { MyHeader, MyFooter },
    }
</script>

<style lang="scss" scoped>
    .main {
       
        .title {
            height: 380px;
            margin-top:80px;
            background: url("./image/aboutUsImg.jpg") no-repeat center center;
            background-size: cover;

            .container {
                h2 {
                    padding-top: 180px;
                    text-align: center;
                    color: #304656;
                    height: 42px;
                    font-size: 32px;
                    font-weight: bold;
                    line-height: 42px;
                    margin-bottom: 2.5rem;
                }

                h3 {
                    text-align: center;
                    height: 29px;
                    font-size: 22px;
                    line-height: 29px;
                    color: #304656;
                }
            }
        }

        .aboutUsInfo {
            .container {
                border-top: 1px solid #E6E6E6;

                .content {
                    margin-top: 30px;
                    overflow: hidden;
                    margin-bottom: 48px;

                    .leftMenu {
                        width: 246px;
                        float: left;

                        ul {
                            li {
                                line-height: 36px;
                                margin-bottom: 10px;

                                &:last-child {
                                    margin-bottom: 0;
                                }

                                &:nth-of-type(2) {}

                                a {
                                    padding: 0 16px;
                                    border-radius: 18px;
                                    display: block;
                                    height: 100%;
                                    overflow: hidden;
                                }

                                i {
                                    display: inline-block;
                                    float: left;
                                    color: #252525;
                                    font-size: 16px;
                                }

                                b {
                                    display: inline-block;
                                    float: right;
                                    width: 30px;
                                    height: 36px;
                                    background: url("./image/yy2.png") no-repeat center center;
                                    background-size: 100%;
                                    line-height: 36px;
                                }

                            }

                            .on {

                                a {
                                    background: #13AE67;
                                }

                                i {
                                    color: #FFFFFF;
                                }

                                b {
                                    background: url("./image/yy.png") no-repeat center center;
                                    background-size: 86%;
                                    transform: rotate(90deg);
                                }
                            }

                            .second {
                                li {
                                    a {
                                        text-indent: 20px;
                                        background: transparent;

                                        i {
                                            color: #252525;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    .rightContent {
                        float: right;
                        margin-left: 88px;
                        width: 866px;

                        h3 {
                            height: 42px;
                            font-size: 26px;
                            font-weight: bold;
                            color: #191919;
                            padding-bottom: 48px;
                        }

                        .textInfo {
                            display: block;
                            font-size: 16px;
                            line-height: 34px;
                            color: #252525;

                            &:before {
                                content: ' ';
                                display: block;
                                height: 3px;
                                width: 40px;
                                background: #888888;
                                margin-bottom: 28px;
                            }

                            p {
                                text-indent: 2em;
                            }
                        }
                    }
                }
            }
        }
    }
</style>